export default __webpack_public_path__ + "static/media/ic-warning.e1480acf.svg";